/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * SelfLearn API
 * OpenAPI specification derived from SelfLearnApi.kt
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BookMarkResponse,
  BookMarkedMemoryCardResponse,
  BookmarkVideo,
  BrainActivityResponse,
  BsReportResponse,
  ChapterUnlockRequestModel,
  ChapterWithProgressResponse,
  DocumentProgress,
  ExerciseLikeDislikeApiBody,
  FeedbackDetailReportOptions,
  GetApiLearnVideoContinueLearnParams,
  GetApiPracticeGetPracticeAnalysisParams,
  GetApiPracticeGetPracticeProgressParams,
  GetApiSelflearnGetAttemptedQuestionsParams,
  GetApiSelflearnGetBookmarkedItemsV3Params,
  GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  GetApiSelflearnGetBookmarkedMemoryCardsParams,
  GetApiSelflearnGetBsAnalysisParams,
  GetApiSelflearnGetHistoryV2Params,
  GetApiSelflearnGetLikeDetailsByQueIdParams,
  GetApiSelflearnGetLikedVideosParams,
  GetApiSelflearnGetMappingParams,
  GetApiSelflearnGetResumeLearningForHomeScreenParams,
  GetApiSelflearnGetResumeVideosParams,
  GetApiSelflearnGetReviseLikeCountParams,
  GetApiSelflearnGetSectionsAndExerciseParams,
  GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  GetApiSelflearnGetTopicSummaryProgressParams,
  GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  GetApiSelflearnGetVideoLikesCountVideoIdParams,
  GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  GetApiSelflearnV2GetPersonalizedTopicsParams,
  GetApiSelflearnV2GetTopicAndVideosProgressParams,
  GetApiSelflearnV2PlaylistParams,
  GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  GetAssetTypeIds,
  GetAttemptedPYQResponse,
  GetFlashCardQuestionsProgressResponse,
  GetLikeDislikeForVs,
  GetLikeIdByQuesId,
  GetPracticeProgressResponse,
  GetPracticeQuestionsResponse,
  GetPyqMappingResponse,
  GetResumeLearningResponse,
  GetReviseLikeCount,
  GetTopicSummaryProgress,
  GuidedLearningTopicsResponse,
  HistoryResponse,
  InternalWidgetOrderResponse,
  LikevideosResponse,
  OrderApiResponse,
  PostApiPracticeSubmitAndGetPracticeQuestionsParams,
  PostApiSelflearnGetPyqMappingV2Params,
  PostAssetFeedbackReport,
  PracticeReportResponse,
  PutApiSelflearnBrainActivityV2Params,
  PutApiSelflearnGetActivityStoriesForChapterParams,
  PutApiSelflearnUpdateUserExamMissedDataParams,
  PuzzleResponse,
  PyqMappingBody,
  ResumeLearningHomeScreenResponse,
  SavePracticeQuestion,
  SectionForChapterResponse,
  StoryResponse,
  SubmitPYQPayload,
  TopicScreenConfigurationResponse,
  TopicWiseVideosProgressResponse,
  UamToCmsMappingResponse,
  UpdateExerciseProgressPayload,
  UpdateFlashCardProgress,
  UpdateQuestionProgress,
  UpdateQuestionProgressForBookExercise,
  UpdateStory,
  VideoLiksResponse,
  VideoSolutionBody,
  VideoSolutionResponse,
  VideosResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Update user exam missed data
 */
export const putApiSelflearnUpdateUserExamMissedData = (
  params: PutApiSelflearnUpdateUserExamMissedDataParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    { url: `/api/selflearn/updateUserExamMissedData`, method: "PUT", params },
    options,
  );
};

export const getPutApiSelflearnUpdateUserExamMissedDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>,
    TError,
    { params: PutApiSelflearnUpdateUserExamMissedDataParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>,
  TError,
  { params: PutApiSelflearnUpdateUserExamMissedDataParams },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateUserExamMissedData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>,
    { params: PutApiSelflearnUpdateUserExamMissedDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiSelflearnUpdateUserExamMissedData(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateUserExamMissedDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>
>;

export type PutApiSelflearnUpdateUserExamMissedDataMutationError = unknown;

/**
 * @summary Update user exam missed data
 */
export const usePutApiSelflearnUpdateUserExamMissedData = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>,
      TError,
      { params: PutApiSelflearnUpdateUserExamMissedDataParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateUserExamMissedData>>,
  TError,
  { params: PutApiSelflearnUpdateUserExamMissedDataParams },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateUserExamMissedDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get UAM to CMS mapping
 */
export const getApiSelflearnGetMapping = (
  params: GetApiSelflearnGetMappingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UamToCmsMappingResponse>(
    { url: `/api/selflearn/getMapping`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetMappingQueryKey = (
  params?: GetApiSelflearnGetMappingParams,
) => {
  return [`/api/selflearn/getMapping`, ...(params ? [params] : [])] as const;
};

export const getGetApiSelflearnGetMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetMappingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetMapping>>
  > = ({ signal }) => getApiSelflearnGetMapping(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetMapping>>
>;
export type GetApiSelflearnGetMappingQueryError = unknown;

export function useGetApiSelflearnGetMapping<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetMappingParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetMapping<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetMapping<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get UAM to CMS mapping
 */

export function useGetApiSelflearnGetMapping<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetMappingQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get video solution by ID
 */
export const getApiSelflearnVideoSolutionVideoSolutionId = (
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideoSolutionResponse>(
    {
      url: `/api/selflearn/videoSolution/${videoSolutionId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnVideoSolutionVideoSolutionIdQueryKey = (
  videoSolutionId?: number,
  params?: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
) => {
  return [
    `/api/selflearn/videoSolution/${videoSolutionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnVideoSolutionVideoSolutionIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnVideoSolutionVideoSolutionIdQueryKey(
      videoSolutionId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>
  > = ({ signal }) =>
    getApiSelflearnVideoSolutionVideoSolutionId(
      videoSolutionId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!videoSolutionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnVideoSolutionVideoSolutionIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>
  >;
export type GetApiSelflearnVideoSolutionVideoSolutionIdQueryError = unknown;

export function useGetApiSelflearnVideoSolutionVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnVideoSolutionVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnVideoSolutionVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video solution by ID
 */

export function useGetApiSelflearnVideoSolutionVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnVideoSolutionVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnVideoSolutionVideoSolutionId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnVideoSolutionVideoSolutionIdQueryOptions(
      videoSolutionId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get practice progress
 */
export const getApiPracticeGetPracticeProgress = (
  params: GetApiPracticeGetPracticeProgressParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetPracticeProgressResponse>(
    { url: `/api/practice/getPracticeProgress`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiPracticeGetPracticeProgressQueryKey = (
  params?: GetApiPracticeGetPracticeProgressParams,
) => {
  return [
    `/api/practice/getPracticeProgress`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiPracticeGetPracticeProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiPracticeGetPracticeProgressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>
  > = ({ signal }) =>
    getApiPracticeGetPracticeProgress(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiPracticeGetPracticeProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>
>;
export type GetApiPracticeGetPracticeProgressQueryError = unknown;

export function useGetApiPracticeGetPracticeProgress<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeProgressParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiPracticeGetPracticeProgress<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiPracticeGetPracticeProgress<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get practice progress
 */

export function useGetApiPracticeGetPracticeProgress<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiPracticeGetPracticeProgressQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get bookmarked items
 */
export const getApiSelflearnGetBookmarkedItemsV3 = (
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BookMarkResponse>(
    {
      url: `/api/selflearn/getBookmarkedItemsV3`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetBookmarkedItemsV3QueryKey = (
  params?: GetApiSelflearnGetBookmarkedItemsV3Params,
) => {
  return [
    `/api/selflearn/getBookmarkedItemsV3`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetBookmarkedItemsV3QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetBookmarkedItemsV3QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>
  > = ({ signal }) =>
    getApiSelflearnGetBookmarkedItemsV3(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetBookmarkedItemsV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>
>;
export type GetApiSelflearnGetBookmarkedItemsV3QueryError = unknown;

export function useGetApiSelflearnGetBookmarkedItemsV3<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedItemsV3<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedItemsV3<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get bookmarked items
 */

export function useGetApiSelflearnGetBookmarkedItemsV3<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedItemsV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedItemsV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetBookmarkedItemsV3QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get liked videos
 */
export const getApiSelflearnGetLikedVideos = (
  params: GetApiSelflearnGetLikedVideosParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<LikevideosResponse[]>(
    { url: `/api/selflearn/getLikedVideos`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetLikedVideosQueryKey = (
  params?: GetApiSelflearnGetLikedVideosParams,
) => {
  return [
    `/api/selflearn/getLikedVideos`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetLikedVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikedVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetLikedVideosQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>
  > = ({ signal }) =>
    getApiSelflearnGetLikedVideos(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetLikedVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>
>;
export type GetApiSelflearnGetLikedVideosQueryError = unknown;

export function useGetApiSelflearnGetLikedVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikedVideosParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetLikedVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikedVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetLikedVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikedVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get liked videos
 */

export function useGetApiSelflearnGetLikedVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikedVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikedVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetLikedVideosQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get book-wise solution report
 */
export const getApiSelflearnGetBsAnalysis = (
  params: GetApiSelflearnGetBsAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BsReportResponse>(
    { url: `/api/selflearn/getBsAnalysis`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetBsAnalysisQueryKey = (
  params?: GetApiSelflearnGetBsAnalysisParams,
) => {
  return [`/api/selflearn/getBsAnalysis`, ...(params ? [params] : [])] as const;
};

export const getGetApiSelflearnGetBsAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBsAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetBsAnalysisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>
  > = ({ signal }) =>
    getApiSelflearnGetBsAnalysis(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetBsAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>
>;
export type GetApiSelflearnGetBsAnalysisQueryError = unknown;

export function useGetApiSelflearnGetBsAnalysis<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBsAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBsAnalysis<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBsAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBsAnalysis<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBsAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get book-wise solution report
 */

export function useGetApiSelflearnGetBsAnalysis<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBsAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBsAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetBsAnalysisQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit practice question and get questions
 */
export const postApiPracticeSubmitAndGetPracticeQuestions = (
  savePracticeQuestion: SavePracticeQuestion,
  params: PostApiPracticeSubmitAndGetPracticeQuestionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetPracticeQuestionsResponse>(
    {
      url: `/api/practice/submitAndGetPracticeQuestions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: savePracticeQuestion,
      params,
      signal,
    },
    options,
  );
};

export const getPostApiPracticeSubmitAndGetPracticeQuestionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>,
    TError,
    {
      data: SavePracticeQuestion;
      params: PostApiPracticeSubmitAndGetPracticeQuestionsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>,
  TError,
  {
    data: SavePracticeQuestion;
    params: PostApiPracticeSubmitAndGetPracticeQuestionsParams;
  },
  TContext
> => {
  const mutationKey = ["postApiPracticeSubmitAndGetPracticeQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>,
    {
      data: SavePracticeQuestion;
      params: PostApiPracticeSubmitAndGetPracticeQuestionsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiPracticeSubmitAndGetPracticeQuestions(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiPracticeSubmitAndGetPracticeQuestionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>
  >;
export type PostApiPracticeSubmitAndGetPracticeQuestionsMutationBody =
  SavePracticeQuestion;
export type PostApiPracticeSubmitAndGetPracticeQuestionsMutationError = unknown;

/**
 * @summary Submit practice question and get questions
 */
export const usePostApiPracticeSubmitAndGetPracticeQuestions = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>,
      TError,
      {
        data: SavePracticeQuestion;
        params: PostApiPracticeSubmitAndGetPracticeQuestionsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiPracticeSubmitAndGetPracticeQuestions>>,
  TError,
  {
    data: SavePracticeQuestion;
    params: PostApiPracticeSubmitAndGetPracticeQuestionsParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostApiPracticeSubmitAndGetPracticeQuestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get internal widget order
 */
export const getApiSelflearnTopicScreenWidgetOrders = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<InternalWidgetOrderResponse>(
    { url: `/api/selflearn/topicScreenWidgetOrders`, method: "GET", signal },
    options,
  );
};

export const getGetApiSelflearnTopicScreenWidgetOrdersQueryKey = () => {
  return [`/api/selflearn/topicScreenWidgetOrders`] as const;
};

export const getGetApiSelflearnTopicScreenWidgetOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnTopicScreenWidgetOrdersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>
  > = ({ signal }) =>
    getApiSelflearnTopicScreenWidgetOrders(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnTopicScreenWidgetOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>
>;
export type GetApiSelflearnTopicScreenWidgetOrdersQueryError = unknown;

export function useGetApiSelflearnTopicScreenWidgetOrders<
  TData = Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnTopicScreenWidgetOrders<
  TData = Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnTopicScreenWidgetOrders<
  TData = Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get internal widget order
 */

export function useGetApiSelflearnTopicScreenWidgetOrders<
  TData = Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnTopicScreenWidgetOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnTopicScreenWidgetOrdersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topic screen configuration
 */
export const getApiSelflearnGetTopicScreenConfiguration = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TopicScreenConfigurationResponse>(
    {
      url: `/api/selflearn/getTopicScreenConfiguration`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetTopicScreenConfigurationQueryKey = () => {
  return [`/api/selflearn/getTopicScreenConfiguration`] as const;
};

export const getGetApiSelflearnGetTopicScreenConfigurationQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetTopicScreenConfigurationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>
  > = ({ signal }) =>
    getApiSelflearnGetTopicScreenConfiguration(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetTopicScreenConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>
>;
export type GetApiSelflearnGetTopicScreenConfigurationQueryError = unknown;

export function useGetApiSelflearnGetTopicScreenConfiguration<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicScreenConfiguration<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicScreenConfiguration<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topic screen configuration
 */

export function useGetApiSelflearnGetTopicScreenConfiguration<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicScreenConfiguration>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetTopicScreenConfigurationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topic summary progress
 */
export const getApiSelflearnGetTopicSummaryProgress = (
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetTopicSummaryProgress>(
    {
      url: `/api/selflearn/getTopicSummaryProgress`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetTopicSummaryProgressQueryKey = (
  params?: GetApiSelflearnGetTopicSummaryProgressParams,
) => {
  return [
    `/api/selflearn/getTopicSummaryProgress`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetTopicSummaryProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetTopicSummaryProgressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>
  > = ({ signal }) =>
    getApiSelflearnGetTopicSummaryProgress(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetTopicSummaryProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>
>;
export type GetApiSelflearnGetTopicSummaryProgressQueryError = unknown;

export function useGetApiSelflearnGetTopicSummaryProgress<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicSummaryProgress<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicSummaryProgress<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topic summary progress
 */

export function useGetApiSelflearnGetTopicSummaryProgress<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetTopicSummaryProgressQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update topic summary progress
 */
export const putApiSelflearnUpdateTopicSummaryProgress = (
  updateFlashCardProgress: UpdateFlashCardProgress,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateTopicSummaryProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFlashCardProgress,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateTopicSummaryProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>,
    TError,
    { data: UpdateFlashCardProgress },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateTopicSummaryProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>,
    { data: UpdateFlashCardProgress }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateTopicSummaryProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateTopicSummaryProgressMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>
  >;
export type PutApiSelflearnUpdateTopicSummaryProgressMutationBody =
  UpdateFlashCardProgress;
export type PutApiSelflearnUpdateTopicSummaryProgressMutationError = unknown;

/**
 * @summary Update topic summary progress
 */
export const usePutApiSelflearnUpdateTopicSummaryProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>,
      TError,
      { data: UpdateFlashCardProgress },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryProgress>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateTopicSummaryProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get flashcard and question progress
 */
export const getApiSelflearnGetTopicSummaryAndQuestions = (
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetFlashCardQuestionsProgressResponse>(
    {
      url: `/api/selflearn/getTopicSummaryAndQuestions`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetTopicSummaryAndQuestionsQueryKey = (
  params?: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
) => {
  return [
    `/api/selflearn/getTopicSummaryAndQuestions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetTopicSummaryAndQuestionsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetTopicSummaryAndQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>
  > = ({ signal }) =>
    getApiSelflearnGetTopicSummaryAndQuestions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetTopicSummaryAndQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>
>;
export type GetApiSelflearnGetTopicSummaryAndQuestionsQueryError = unknown;

export function useGetApiSelflearnGetTopicSummaryAndQuestions<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicSummaryAndQuestions<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetTopicSummaryAndQuestions<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get flashcard and question progress
 */

export function useGetApiSelflearnGetTopicSummaryAndQuestions<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetTopicSummaryAndQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetTopicSummaryAndQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetTopicSummaryAndQuestionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get revise like count
 */
export const getApiSelflearnGetReviseLikeCount = (
  params: GetApiSelflearnGetReviseLikeCountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetReviseLikeCount>(
    { url: `/api/selflearn/getReviseLikeCount`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetReviseLikeCountQueryKey = (
  params?: GetApiSelflearnGetReviseLikeCountParams,
) => {
  return [
    `/api/selflearn/getReviseLikeCount`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetReviseLikeCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetReviseLikeCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetReviseLikeCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>
  > = ({ signal }) =>
    getApiSelflearnGetReviseLikeCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetReviseLikeCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>
>;
export type GetApiSelflearnGetReviseLikeCountQueryError = unknown;

export function useGetApiSelflearnGetReviseLikeCount<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetReviseLikeCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetReviseLikeCount<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetReviseLikeCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetReviseLikeCount<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetReviseLikeCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get revise like count
 */

export function useGetApiSelflearnGetReviseLikeCount<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetReviseLikeCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetReviseLikeCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetReviseLikeCountQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update memory card progress
 */
export const putApiSelflearnUpdateMemoryCardProgress = (
  updateFlashCardProgress: UpdateFlashCardProgress,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateMemoryCardProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFlashCardProgress,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateMemoryCardProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>,
    TError,
    { data: UpdateFlashCardProgress },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateMemoryCardProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>,
    { data: UpdateFlashCardProgress }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateMemoryCardProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateMemoryCardProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>
>;
export type PutApiSelflearnUpdateMemoryCardProgressMutationBody =
  UpdateFlashCardProgress;
export type PutApiSelflearnUpdateMemoryCardProgressMutationError = unknown;

/**
 * @summary Update memory card progress
 */
export const usePutApiSelflearnUpdateMemoryCardProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>,
      TError,
      { data: UpdateFlashCardProgress },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateMemoryCardProgress>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateMemoryCardProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update card of day
 */
export const putApiSelflearnUpdateCardOfDay = (
  updateFlashCardProgress: UpdateFlashCardProgress,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateCardOfDay`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFlashCardProgress,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateCardOfDayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>,
    TError,
    { data: UpdateFlashCardProgress },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateCardOfDay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>,
    { data: UpdateFlashCardProgress }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateCardOfDay(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateCardOfDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>
>;
export type PutApiSelflearnUpdateCardOfDayMutationBody =
  UpdateFlashCardProgress;
export type PutApiSelflearnUpdateCardOfDayMutationError = unknown;

/**
 * @summary Update card of day
 */
export const usePutApiSelflearnUpdateCardOfDay = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>,
      TError,
      { data: UpdateFlashCardProgress },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateCardOfDay>>,
  TError,
  { data: UpdateFlashCardProgress },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateCardOfDayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Store BS question progress
 */
export const putApiSelflearnStoreBsQuestionProgress = (
  updateQuestionProgressForBookExercise: UpdateQuestionProgressForBookExercise,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/storeBsQuestionProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateQuestionProgressForBookExercise,
    },
    options,
  );
};

export const getPutApiSelflearnStoreBsQuestionProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>,
    TError,
    { data: UpdateQuestionProgressForBookExercise },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>,
  TError,
  { data: UpdateQuestionProgressForBookExercise },
  TContext
> => {
  const mutationKey = ["putApiSelflearnStoreBsQuestionProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>,
    { data: UpdateQuestionProgressForBookExercise }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnStoreBsQuestionProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnStoreBsQuestionProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>
>;
export type PutApiSelflearnStoreBsQuestionProgressMutationBody =
  UpdateQuestionProgressForBookExercise;
export type PutApiSelflearnStoreBsQuestionProgressMutationError = unknown;

/**
 * @summary Store BS question progress
 */
export const usePutApiSelflearnStoreBsQuestionProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>,
      TError,
      { data: UpdateQuestionProgressForBookExercise },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnStoreBsQuestionProgress>>,
  TError,
  { data: UpdateQuestionProgressForBookExercise },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnStoreBsQuestionProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update topic summary question
 */
export const putApiSelflearnUpdateTopicSummaryQuestion = (
  updateQuestionProgress: UpdateQuestionProgress,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateTopicSummaryQuestion`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateQuestionProgress,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateTopicSummaryQuestionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>,
    TError,
    { data: UpdateQuestionProgress },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>,
  TError,
  { data: UpdateQuestionProgress },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateTopicSummaryQuestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>,
    { data: UpdateQuestionProgress }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateTopicSummaryQuestion(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateTopicSummaryQuestionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>
  >;
export type PutApiSelflearnUpdateTopicSummaryQuestionMutationBody =
  UpdateQuestionProgress;
export type PutApiSelflearnUpdateTopicSummaryQuestionMutationError = unknown;

/**
 * @summary Update topic summary question
 */
export const usePutApiSelflearnUpdateTopicSummaryQuestion = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>,
      TError,
      { data: UpdateQuestionProgress },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateTopicSummaryQuestion>>,
  TError,
  { data: UpdateQuestionProgress },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateTopicSummaryQuestionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get widget orders
 */
export const getApiSelflearnWidgetorders = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OrderApiResponse>(
    { url: `/api/selflearn/widgetorders`, method: "GET", signal },
    options,
  );
};

export const getGetApiSelflearnWidgetordersQueryKey = () => {
  return [`/api/selflearn/widgetorders`] as const;
};

export const getGetApiSelflearnWidgetordersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnWidgetordersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>
  > = ({ signal }) => getApiSelflearnWidgetorders(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnWidgetordersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>
>;
export type GetApiSelflearnWidgetordersQueryError = unknown;

export function useGetApiSelflearnWidgetorders<
  TData = Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnWidgetorders<
  TData = Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnWidgetorders<
  TData = Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get widget orders
 */

export function useGetApiSelflearnWidgetorders<
  TData = Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnWidgetorders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnWidgetordersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get chapters with progress and lock status
 */
export const getApiSelflearnV2GetChaptersWithProgressAndLockStatus = (
  params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChapterWithProgressResponse>(
    {
      url: `/api/selflearn/v2/getChaptersWithProgressAndLockStatus`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryKey =
  (params?: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams) => {
    return [
      `/api/selflearn/v2/getChaptersWithProgressAndLockStatus`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
    >,
    TError = unknown,
  >(
    params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
      >
    > = ({ signal }) =>
      getApiSelflearnV2GetChaptersWithProgressAndLockStatus(
        params,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
    >
  >;
export type GetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryError =
  unknown;

export function useGetApiSelflearnV2GetChaptersWithProgressAndLockStatus<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetChaptersWithProgressAndLockStatus<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetChaptersWithProgressAndLockStatus<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get chapters with progress and lock status
 */

export function useGetApiSelflearnV2GetChaptersWithProgressAndLockStatus<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetChaptersWithProgressAndLockStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnV2GetChaptersWithProgressAndLockStatus
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnV2GetChaptersWithProgressAndLockStatusQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get bookmarked memory cards
 */
export const getApiSelflearnGetBookmarkedMemoryCards = (
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BookMarkedMemoryCardResponse>(
    {
      url: `/api/selflearn/getBookmarkedMemoryCards`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetBookmarkedMemoryCardsQueryKey = (
  params?: GetApiSelflearnGetBookmarkedMemoryCardsParams,
) => {
  return [
    `/api/selflearn/getBookmarkedMemoryCards`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetBookmarkedMemoryCardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetBookmarkedMemoryCardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>
  > = ({ signal }) =>
    getApiSelflearnGetBookmarkedMemoryCards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetBookmarkedMemoryCardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>
>;
export type GetApiSelflearnGetBookmarkedMemoryCardsQueryError = unknown;

export function useGetApiSelflearnGetBookmarkedMemoryCards<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedMemoryCards<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedMemoryCards<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get bookmarked memory cards
 */

export function useGetApiSelflearnGetBookmarkedMemoryCards<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetBookmarkedMemoryCardsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get bookmarked memory cards by chapter
 */
export const getApiSelflearnGetBookmarkedMemoryCardsByChapter = (
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BookMarkedMemoryCardResponse>(
    {
      url: `/api/selflearn/getBookmarkedMemoryCardsByChapter`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryKey = (
  params?: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
) => {
  return [
    `/api/selflearn/getBookmarkedMemoryCardsByChapter`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>>
  > = ({ signal }) =>
    getApiSelflearnGetBookmarkedMemoryCardsByChapter(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>>
  >;
export type GetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryError =
  unknown;

export function useGetApiSelflearnGetBookmarkedMemoryCardsByChapter<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedMemoryCardsByChapter<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetBookmarkedMemoryCardsByChapter<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get bookmarked memory cards by chapter
 */

export function useGetApiSelflearnGetBookmarkedMemoryCardsByChapter<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetBookmarkedMemoryCardsByChapterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetBookmarkedMemoryCardsByChapter>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetBookmarkedMemoryCardsByChapterQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get practice analysis
 */
export const getApiPracticeGetPracticeAnalysis = (
  params: GetApiPracticeGetPracticeAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PracticeReportResponse>(
    { url: `/api/practice/getPracticeAnalysis`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiPracticeGetPracticeAnalysisQueryKey = (
  params?: GetApiPracticeGetPracticeAnalysisParams,
) => {
  return [
    `/api/practice/getPracticeAnalysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiPracticeGetPracticeAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiPracticeGetPracticeAnalysisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>
  > = ({ signal }) =>
    getApiPracticeGetPracticeAnalysis(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiPracticeGetPracticeAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>
>;
export type GetApiPracticeGetPracticeAnalysisQueryError = unknown;

export function useGetApiPracticeGetPracticeAnalysis<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiPracticeGetPracticeAnalysis<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiPracticeGetPracticeAnalysis<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get practice analysis
 */

export function useGetApiPracticeGetPracticeAnalysis<
  TData = Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
  TError = unknown,
>(
  params: GetApiPracticeGetPracticeAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiPracticeGetPracticeAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiPracticeGetPracticeAnalysisQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topic and videos progress
 */
export const getApiSelflearnV2GetTopicAndVideosProgress = (
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TopicWiseVideosProgressResponse>(
    {
      url: `/api/selflearn/v2/getTopicAndVideosProgress`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnV2GetTopicAndVideosProgressQueryKey = (
  params?: GetApiSelflearnV2GetTopicAndVideosProgressParams,
) => {
  return [
    `/api/selflearn/v2/getTopicAndVideosProgress`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnV2GetTopicAndVideosProgressQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnV2GetTopicAndVideosProgressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>
  > = ({ signal }) =>
    getApiSelflearnV2GetTopicAndVideosProgress(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnV2GetTopicAndVideosProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>
>;
export type GetApiSelflearnV2GetTopicAndVideosProgressQueryError = unknown;

export function useGetApiSelflearnV2GetTopicAndVideosProgress<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetTopicAndVideosProgress<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
          >,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetTopicAndVideosProgress<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topic and videos progress
 */

export function useGetApiSelflearnV2GetTopicAndVideosProgress<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetTopicAndVideosProgressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetTopicAndVideosProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnV2GetTopicAndVideosProgressQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get video details for playlist type
 */
export const getApiSelflearnGetVideoDetailsForPlayListTypeId = (
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TopicWiseVideosProgressResponse>(
    {
      url: `/api/selflearn/getVideoDetailsForPlayListTypeId`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryKey = (
  params?: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
) => {
  return [
    `/api/selflearn/getVideoDetailsForPlayListTypeId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>>
  > = ({ signal }) =>
    getApiSelflearnGetVideoDetailsForPlayListTypeId(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>>
  >;
export type GetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryError = unknown;

export function useGetApiSelflearnGetVideoDetailsForPlayListTypeId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoDetailsForPlayListTypeId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoDetailsForPlayListTypeId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video details for playlist type
 */

export function useGetApiSelflearnGetVideoDetailsForPlayListTypeId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetVideoDetailsForPlayListTypeIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetVideoDetailsForPlayListTypeId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetVideoDetailsForPlayListTypeIdQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get continue learn videos
 */
export const getApiLearnVideoContinueLearn = (
  params: GetApiLearnVideoContinueLearnParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideosResponse>(
    { url: `/api/learn/video/continueLearn`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiLearnVideoContinueLearnQueryKey = (
  params?: GetApiLearnVideoContinueLearnParams,
) => {
  return [
    `/api/learn/video/continueLearn`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLearnVideoContinueLearnQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
  TError = unknown,
>(
  params: GetApiLearnVideoContinueLearnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLearnVideoContinueLearnQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>
  > = ({ signal }) =>
    getApiLearnVideoContinueLearn(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLearnVideoContinueLearnQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>
>;
export type GetApiLearnVideoContinueLearnQueryError = unknown;

export function useGetApiLearnVideoContinueLearn<
  TData = Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
  TError = unknown,
>(
  params: GetApiLearnVideoContinueLearnParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
          TError,
          Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLearnVideoContinueLearn<
  TData = Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
  TError = unknown,
>(
  params: GetApiLearnVideoContinueLearnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
          TError,
          Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLearnVideoContinueLearn<
  TData = Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
  TError = unknown,
>(
  params: GetApiLearnVideoContinueLearnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get continue learn videos
 */

export function useGetApiLearnVideoContinueLearn<
  TData = Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
  TError = unknown,
>(
  params: GetApiLearnVideoContinueLearnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLearnVideoContinueLearn>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLearnVideoContinueLearnQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get puzzles list (playlist)
 */
export const getApiSelflearnV2Playlist = (
  params: GetApiSelflearnV2PlaylistParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PuzzleResponse>(
    { url: `/api/selflearn/v2/playlist`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnV2PlaylistQueryKey = (
  params?: GetApiSelflearnV2PlaylistParams,
) => {
  return [`/api/selflearn/v2/playlist`, ...(params ? [params] : [])] as const;
};

export const getGetApiSelflearnV2PlaylistQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2PlaylistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnV2PlaylistQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>
  > = ({ signal }) => getApiSelflearnV2Playlist(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnV2PlaylistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>
>;
export type GetApiSelflearnV2PlaylistQueryError = unknown;

export function useGetApiSelflearnV2Playlist<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2PlaylistParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2Playlist<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2PlaylistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2Playlist<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2PlaylistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get puzzles list (playlist)
 */

export function useGetApiSelflearnV2Playlist<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2PlaylistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2Playlist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnV2PlaylistQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get history
 */
export const getApiSelflearnGetHistoryV2 = (
  params: GetApiSelflearnGetHistoryV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<HistoryResponse>(
    { url: `/api/selflearn/getHistoryV2`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetHistoryV2QueryKey = (
  params?: GetApiSelflearnGetHistoryV2Params,
) => {
  return [`/api/selflearn/getHistoryV2`, ...(params ? [params] : [])] as const;
};

export const getGetApiSelflearnGetHistoryV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetHistoryV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>
  > = ({ signal }) =>
    getApiSelflearnGetHistoryV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetHistoryV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>
>;
export type GetApiSelflearnGetHistoryV2QueryError = unknown;

export function useGetApiSelflearnGetHistoryV2<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetHistoryV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetHistoryV2<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetHistoryV2<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get history
 */

export function useGetApiSelflearnGetHistoryV2<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetHistoryV2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetHistoryV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Store video progress
 */
export const putApiSelflearnStoreVideoProgress = (
  bookmarkVideo: BookmarkVideo,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/storeVideoProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: bookmarkVideo,
    },
    options,
  );
};

export const getPutApiSelflearnStoreVideoProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>,
    TError,
    { data: BookmarkVideo },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>,
  TError,
  { data: BookmarkVideo },
  TContext
> => {
  const mutationKey = ["putApiSelflearnStoreVideoProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>,
    { data: BookmarkVideo }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnStoreVideoProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnStoreVideoProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>
>;
export type PutApiSelflearnStoreVideoProgressMutationBody = BookmarkVideo;
export type PutApiSelflearnStoreVideoProgressMutationError = unknown;

/**
 * @summary Store video progress
 */
export const usePutApiSelflearnStoreVideoProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>,
      TError,
      { data: BookmarkVideo },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnStoreVideoProgress>>,
  TError,
  { data: BookmarkVideo },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnStoreVideoProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit video solution
 */
export const putApiSelflearnVideoSolution = (
  videoSolutionBody: VideoSolutionBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/videoSolution`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: videoSolutionBody,
    },
    options,
  );
};

export const getPutApiSelflearnVideoSolutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>,
    TError,
    { data: VideoSolutionBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>,
  TError,
  { data: VideoSolutionBody },
  TContext
> => {
  const mutationKey = ["putApiSelflearnVideoSolution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>,
    { data: VideoSolutionBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnVideoSolution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnVideoSolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>
>;
export type PutApiSelflearnVideoSolutionMutationBody = VideoSolutionBody;
export type PutApiSelflearnVideoSolutionMutationError = unknown;

/**
 * @summary Submit video solution
 */
export const usePutApiSelflearnVideoSolution = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>,
      TError,
      { data: VideoSolutionBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnVideoSolution>>,
  TError,
  { data: VideoSolutionBody },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnVideoSolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update story progress
 */
export const putApiSelflearnUpdateStoryProgress = (
  updateStory: UpdateStory,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateStoryProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateStory,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateStoryProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>,
    TError,
    { data: UpdateStory },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>,
  TError,
  { data: UpdateStory },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateStoryProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>,
    { data: UpdateStory }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateStoryProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateStoryProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>
>;
export type PutApiSelflearnUpdateStoryProgressMutationBody = UpdateStory;
export type PutApiSelflearnUpdateStoryProgressMutationError = unknown;

/**
 * @summary Update story progress
 */
export const usePutApiSelflearnUpdateStoryProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>,
      TError,
      { data: UpdateStory },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateStoryProgress>>,
  TError,
  { data: UpdateStory },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateStoryProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update user document progress
 */
export const putApiSelflearnUserDocumentProgress = (
  documentProgress: DocumentProgress,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/userDocumentProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: documentProgress,
    },
    options,
  );
};

export const getPutApiSelflearnUserDocumentProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>,
    TError,
    { data: DocumentProgress },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>,
  TError,
  { data: DocumentProgress },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUserDocumentProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>,
    { data: DocumentProgress }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUserDocumentProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUserDocumentProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>
>;
export type PutApiSelflearnUserDocumentProgressMutationBody = DocumentProgress;
export type PutApiSelflearnUserDocumentProgressMutationError = unknown;

/**
 * @summary Update user document progress
 */
export const usePutApiSelflearnUserDocumentProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>,
      TError,
      { data: DocumentProgress },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUserDocumentProgress>>,
  TError,
  { data: DocumentProgress },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUserDocumentProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get resume learning videos
 */
export const getApiSelflearnGetResumeVideos = (
  params: GetApiSelflearnGetResumeVideosParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetResumeLearningResponse[]>(
    { url: `/api/selflearn/getResumeVideos`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiSelflearnGetResumeVideosQueryKey = (
  params?: GetApiSelflearnGetResumeVideosParams,
) => {
  return [
    `/api/selflearn/getResumeVideos`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetResumeVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetResumeVideosQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>
  > = ({ signal }) =>
    getApiSelflearnGetResumeVideos(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetResumeVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>
>;
export type GetApiSelflearnGetResumeVideosQueryError = unknown;

export function useGetApiSelflearnGetResumeVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeVideosParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetResumeVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetResumeVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get resume learning videos
 */

export function useGetApiSelflearnGetResumeVideos<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetResumeVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetResumeVideosQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get resume learning for home
 */
export const getApiSelflearnGetResumeLearningForHomeScreen = (
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ResumeLearningHomeScreenResponse>(
    {
      url: `/api/selflearn/getResumeLearningForHomeScreen`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetResumeLearningForHomeScreenQueryKey = (
  params?: GetApiSelflearnGetResumeLearningForHomeScreenParams,
) => {
  return [
    `/api/selflearn/getResumeLearningForHomeScreen`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetResumeLearningForHomeScreenQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetResumeLearningForHomeScreenQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>>
  > = ({ signal }) =>
    getApiSelflearnGetResumeLearningForHomeScreen(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetResumeLearningForHomeScreenQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>>
  >;
export type GetApiSelflearnGetResumeLearningForHomeScreenQueryError = unknown;

export function useGetApiSelflearnGetResumeLearningForHomeScreen<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetResumeLearningForHomeScreen<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetResumeLearningForHomeScreen<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get resume learning for home
 */

export function useGetApiSelflearnGetResumeLearningForHomeScreen<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
  >,
  TError = unknown,
>(
  params: GetApiSelflearnGetResumeLearningForHomeScreenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiSelflearnGetResumeLearningForHomeScreen>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetResumeLearningForHomeScreenQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get sections and exercise for chapter
 */
export const getApiSelflearnGetSectionsAndExercise = (
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SectionForChapterResponse>(
    {
      url: `/api/selflearn/getSectionsAndExercise`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetSectionsAndExerciseQueryKey = (
  params?: GetApiSelflearnGetSectionsAndExerciseParams,
) => {
  return [
    `/api/selflearn/getSectionsAndExercise`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetSectionsAndExerciseQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetSectionsAndExerciseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>
  > = ({ signal }) =>
    getApiSelflearnGetSectionsAndExercise(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetSectionsAndExerciseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>
>;
export type GetApiSelflearnGetSectionsAndExerciseQueryError = unknown;

export function useGetApiSelflearnGetSectionsAndExercise<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetSectionsAndExercise<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetSectionsAndExercise<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get sections and exercise for chapter
 */

export function useGetApiSelflearnGetSectionsAndExercise<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetSectionsAndExerciseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetSectionsAndExercise>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetSectionsAndExerciseQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get activity stories for chapter
 */
export const putApiSelflearnGetActivityStoriesForChapter = (
  params: PutApiSelflearnGetActivityStoriesForChapterParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<StoryResponse>(
    {
      url: `/api/selflearn/getActivityStoriesForChapter`,
      method: "PUT",
      params,
    },
    options,
  );
};

export const getPutApiSelflearnGetActivityStoriesForChapterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>,
    TError,
    { params: PutApiSelflearnGetActivityStoriesForChapterParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>,
  TError,
  { params: PutApiSelflearnGetActivityStoriesForChapterParams },
  TContext
> => {
  const mutationKey = ["putApiSelflearnGetActivityStoriesForChapter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>,
    { params: PutApiSelflearnGetActivityStoriesForChapterParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiSelflearnGetActivityStoriesForChapter(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnGetActivityStoriesForChapterMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>
  >;

export type PutApiSelflearnGetActivityStoriesForChapterMutationError = unknown;

/**
 * @summary Get activity stories for chapter
 */
export const usePutApiSelflearnGetActivityStoriesForChapter = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>,
      TError,
      { params: PutApiSelflearnGetActivityStoriesForChapterParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnGetActivityStoriesForChapter>>,
  TError,
  { params: PutApiSelflearnGetActivityStoriesForChapterParams },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnGetActivityStoriesForChapterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get brain activity
 */
export const putApiSelflearnBrainActivityV2 = (
  params: PutApiSelflearnBrainActivityV2Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<BrainActivityResponse>(
    { url: `/api/selflearn/brainActivityV2`, method: "PUT", params },
    options,
  );
};

export const getPutApiSelflearnBrainActivityV2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>,
    TError,
    { params: PutApiSelflearnBrainActivityV2Params },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>,
  TError,
  { params: PutApiSelflearnBrainActivityV2Params },
  TContext
> => {
  const mutationKey = ["putApiSelflearnBrainActivityV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>,
    { params: PutApiSelflearnBrainActivityV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return putApiSelflearnBrainActivityV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnBrainActivityV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>
>;

export type PutApiSelflearnBrainActivityV2MutationError = unknown;

/**
 * @summary Get brain activity
 */
export const usePutApiSelflearnBrainActivityV2 = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>,
      TError,
      { params: PutApiSelflearnBrainActivityV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnBrainActivityV2>>,
  TError,
  { params: PutApiSelflearnBrainActivityV2Params },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnBrainActivityV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update exercise progress
 */
export const putApiSelflearnUpdateExerciseProgress = (
  updateExerciseProgressPayload: UpdateExerciseProgressPayload,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/updateExerciseProgress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateExerciseProgressPayload,
    },
    options,
  );
};

export const getPutApiSelflearnUpdateExerciseProgressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>,
    TError,
    { data: UpdateExerciseProgressPayload },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>,
  TError,
  { data: UpdateExerciseProgressPayload },
  TContext
> => {
  const mutationKey = ["putApiSelflearnUpdateExerciseProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>,
    { data: UpdateExerciseProgressPayload }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnUpdateExerciseProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnUpdateExerciseProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>
>;
export type PutApiSelflearnUpdateExerciseProgressMutationBody =
  UpdateExerciseProgressPayload;
export type PutApiSelflearnUpdateExerciseProgressMutationError = unknown;

/**
 * @summary Update exercise progress
 */
export const usePutApiSelflearnUpdateExerciseProgress = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>,
      TError,
      { data: UpdateExerciseProgressPayload },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnUpdateExerciseProgress>>,
  TError,
  { data: UpdateExerciseProgressPayload },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnUpdateExerciseProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Redeem and unlock chapter
 */
export const putApiSelflearnRedeemAndUnlockChapterV2 = (
  chapterUnlockRequestModel: ChapterUnlockRequestModel,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/redeemAndUnlockChapterV2`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: chapterUnlockRequestModel,
    },
    options,
  );
};

export const getPutApiSelflearnRedeemAndUnlockChapterV2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>,
    TError,
    { data: ChapterUnlockRequestModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>,
  TError,
  { data: ChapterUnlockRequestModel },
  TContext
> => {
  const mutationKey = ["putApiSelflearnRedeemAndUnlockChapterV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>,
    { data: ChapterUnlockRequestModel }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnRedeemAndUnlockChapterV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnRedeemAndUnlockChapterV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>
>;
export type PutApiSelflearnRedeemAndUnlockChapterV2MutationBody =
  ChapterUnlockRequestModel;
export type PutApiSelflearnRedeemAndUnlockChapterV2MutationError = unknown;

/**
 * @summary Redeem and unlock chapter
 */
export const usePutApiSelflearnRedeemAndUnlockChapterV2 = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>,
      TError,
      { data: ChapterUnlockRequestModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnRedeemAndUnlockChapterV2>>,
  TError,
  { data: ChapterUnlockRequestModel },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnRedeemAndUnlockChapterV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get PYQ mapping
 */
export const postApiSelflearnGetPyqMappingV2 = (
  pyqMappingBody: PyqMappingBody,
  params: PostApiSelflearnGetPyqMappingV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetPyqMappingResponse>(
    {
      url: `/api/selflearn/getPyqMappingV2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pyqMappingBody,
      params,
      signal,
    },
    options,
  );
};

export const getPostApiSelflearnGetPyqMappingV2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>,
    TError,
    { data: PyqMappingBody; params: PostApiSelflearnGetPyqMappingV2Params },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>,
  TError,
  { data: PyqMappingBody; params: PostApiSelflearnGetPyqMappingV2Params },
  TContext
> => {
  const mutationKey = ["postApiSelflearnGetPyqMappingV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>,
    { data: PyqMappingBody; params: PostApiSelflearnGetPyqMappingV2Params }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiSelflearnGetPyqMappingV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSelflearnGetPyqMappingV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>
>;
export type PostApiSelflearnGetPyqMappingV2MutationBody = PyqMappingBody;
export type PostApiSelflearnGetPyqMappingV2MutationError = unknown;

/**
 * @summary Get PYQ mapping
 */
export const usePostApiSelflearnGetPyqMappingV2 = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>,
      TError,
      { data: PyqMappingBody; params: PostApiSelflearnGetPyqMappingV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiSelflearnGetPyqMappingV2>>,
  TError,
  { data: PyqMappingBody; params: PostApiSelflearnGetPyqMappingV2Params },
  TContext
> => {
  const mutationOptions =
    getPostApiSelflearnGetPyqMappingV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit previous year questions
 */
export const putApiSelflearnPreviousYearQuestions = (
  submitPYQPayload: SubmitPYQPayload,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/previousYearQuestions`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: submitPYQPayload,
    },
    options,
  );
};

export const getPutApiSelflearnPreviousYearQuestionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>,
    TError,
    { data: SubmitPYQPayload },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>,
  TError,
  { data: SubmitPYQPayload },
  TContext
> => {
  const mutationKey = ["putApiSelflearnPreviousYearQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>,
    { data: SubmitPYQPayload }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnPreviousYearQuestions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnPreviousYearQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>
>;
export type PutApiSelflearnPreviousYearQuestionsMutationBody = SubmitPYQPayload;
export type PutApiSelflearnPreviousYearQuestionsMutationError = unknown;

/**
 * @summary Submit previous year questions
 */
export const usePutApiSelflearnPreviousYearQuestions = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>,
      TError,
      { data: SubmitPYQPayload },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnPreviousYearQuestions>>,
  TError,
  { data: SubmitPYQPayload },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnPreviousYearQuestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get attempted PYQ questions
 */
export const getApiSelflearnGetAttemptedQuestions = (
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAttemptedPYQResponse>(
    {
      url: `/api/selflearn/getAttemptedQuestions`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetAttemptedQuestionsQueryKey = (
  params?: GetApiSelflearnGetAttemptedQuestionsParams,
) => {
  return [
    `/api/selflearn/getAttemptedQuestions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetAttemptedQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetAttemptedQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>
  > = ({ signal }) =>
    getApiSelflearnGetAttemptedQuestions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetAttemptedQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>
>;
export type GetApiSelflearnGetAttemptedQuestionsQueryError = unknown;

export function useGetApiSelflearnGetAttemptedQuestions<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAttemptedQuestions<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAttemptedQuestions<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get attempted PYQ questions
 */

export function useGetApiSelflearnGetAttemptedQuestions<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetAttemptedQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAttemptedQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetAttemptedQuestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get asset report options
 */
export const getApiSelflearnGetAssetReportOptionsAssetId = (
  assetId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackDetailReportOptions[]>(
    {
      url: `/api/selflearn/getAssetReportOptions/${assetId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetAssetReportOptionsAssetIdQueryKey = (
  assetId?: number,
) => {
  return [`/api/selflearn/getAssetReportOptions/${assetId}`] as const;
};

export const getGetApiSelflearnGetAssetReportOptionsAssetIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
  >,
  TError = unknown,
>(
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetAssetReportOptionsAssetIdQueryKey(assetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>
  > = ({ signal }) =>
    getApiSelflearnGetAssetReportOptionsAssetId(
      assetId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!assetId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetAssetReportOptionsAssetIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>
  >;
export type GetApiSelflearnGetAssetReportOptionsAssetIdQueryError = unknown;

export function useGetApiSelflearnGetAssetReportOptionsAssetId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
  >,
  TError = unknown,
>(
  assetId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAssetReportOptionsAssetId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
  >,
  TError = unknown,
>(
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAssetReportOptionsAssetId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
  >,
  TError = unknown,
>(
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset report options
 */

export function useGetApiSelflearnGetAssetReportOptionsAssetId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>
  >,
  TError = unknown,
>(
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetReportOptionsAssetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetAssetReportOptionsAssetIdQueryOptions(
      assetId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get video likes count
 */
export const getApiSelflearnGetVideoLikesCountVideoId = (
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideoLiksResponse>(
    {
      url: `/api/selflearn/getVideoLikesCount/${videoId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetVideoLikesCountVideoIdQueryKey = (
  videoId?: number,
  params?: GetApiSelflearnGetVideoLikesCountVideoIdParams,
) => {
  return [
    `/api/selflearn/getVideoLikesCount/${videoId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetVideoLikesCountVideoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
  TError = unknown,
>(
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetVideoLikesCountVideoIdQueryKey(videoId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>
  > = ({ signal }) =>
    getApiSelflearnGetVideoLikesCountVideoId(
      videoId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!videoId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetVideoLikesCountVideoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>
>;
export type GetApiSelflearnGetVideoLikesCountVideoIdQueryError = unknown;

export function useGetApiSelflearnGetVideoLikesCountVideoId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
  TError = unknown,
>(
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoLikesCountVideoId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
  TError = unknown,
>(
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoLikesCountVideoId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
  TError = unknown,
>(
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video likes count
 */

export function useGetApiSelflearnGetVideoLikesCountVideoId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
  TError = unknown,
>(
  videoId: number,
  params: GetApiSelflearnGetVideoLikesCountVideoIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetVideoLikesCountVideoId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetVideoLikesCountVideoIdQueryOptions(
    videoId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get video solution likes count
 */
export const getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId = (
  videoSolutionId: number,
  params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetLikeDislikeForVs>(
    {
      url: `/api/selflearn/getVideoSolutionLikesCount/${videoSolutionId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryKey =
  (
    videoSolutionId?: number,
    params?: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  ) => {
    return [
      `/api/selflearn/getVideoSolutionLikesCount/${videoSolutionId}`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
      >
    >,
    TError = unknown,
  >(
    videoSolutionId: number,
    params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryKey(
        videoSolutionId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
        >
      >
    > = ({ signal }) =>
      getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId(
        videoSolutionId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!videoSolutionId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
      >
    >
  >;
export type GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryError =
  unknown;

export function useGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video solution likes count
 */

export function useGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionId<
  TData = Awaited<
    ReturnType<typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId>
  >,
  TError = unknown,
>(
  videoSolutionId: number,
  params: GetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiSelflearnGetVideoSolutionLikesCountVideoSolutionId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiSelflearnGetVideoSolutionLikesCountVideoSolutionIdQueryOptions(
      videoSolutionId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get like details by question ID
 */
export const getApiSelflearnGetLikeDetailsByQueId = (
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetLikeIdByQuesId[]>(
    {
      url: `/api/selflearn/getLikeDetailsByQueId`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnGetLikeDetailsByQueIdQueryKey = (
  params?: GetApiSelflearnGetLikeDetailsByQueIdParams,
) => {
  return [
    `/api/selflearn/getLikeDetailsByQueId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnGetLikeDetailsByQueIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnGetLikeDetailsByQueIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>
  > = ({ signal }) =>
    getApiSelflearnGetLikeDetailsByQueId(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetLikeDetailsByQueIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>
>;
export type GetApiSelflearnGetLikeDetailsByQueIdQueryError = unknown;

export function useGetApiSelflearnGetLikeDetailsByQueId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetLikeDetailsByQueId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetLikeDetailsByQueId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get like details by question ID
 */

export function useGetApiSelflearnGetLikeDetailsByQueId<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
  TError = unknown,
>(
  params: GetApiSelflearnGetLikeDetailsByQueIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetLikeDetailsByQueId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetLikeDetailsByQueIdQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit like/dislike for question
 */
export const putApiSelflearnSubmitLikeDisLikeForQuestion = (
  exerciseLikeDislikeApiBody: ExerciseLikeDislikeApiBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/submitLikeDisLikeForQuestion`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: exerciseLikeDislikeApiBody,
    },
    options,
  );
};

export const getPutApiSelflearnSubmitLikeDisLikeForQuestionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>,
    TError,
    { data: ExerciseLikeDislikeApiBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>,
  TError,
  { data: ExerciseLikeDislikeApiBody },
  TContext
> => {
  const mutationKey = ["putApiSelflearnSubmitLikeDisLikeForQuestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>,
    { data: ExerciseLikeDislikeApiBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnSubmitLikeDisLikeForQuestion(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnSubmitLikeDisLikeForQuestionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>
  >;
export type PutApiSelflearnSubmitLikeDisLikeForQuestionMutationBody =
  ExerciseLikeDislikeApiBody;
export type PutApiSelflearnSubmitLikeDisLikeForQuestionMutationError = unknown;

/**
 * @summary Submit like/dislike for question
 */
export const usePutApiSelflearnSubmitLikeDisLikeForQuestion = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>,
      TError,
      { data: ExerciseLikeDislikeApiBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnSubmitLikeDisLikeForQuestion>>,
  TError,
  { data: ExerciseLikeDislikeApiBody },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnSubmitLikeDisLikeForQuestionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Post asset feedback report
 */
export const putApiSelflearnPostAssetFeedBackReport = (
  postAssetFeedbackReport: PostAssetFeedbackReport,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<boolean>(
    {
      url: `/api/selflearn/postAssetFeedBackReport`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: postAssetFeedbackReport,
    },
    options,
  );
};

export const getPutApiSelflearnPostAssetFeedBackReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>,
    TError,
    { data: PostAssetFeedbackReport },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>,
  TError,
  { data: PostAssetFeedbackReport },
  TContext
> => {
  const mutationKey = ["putApiSelflearnPostAssetFeedBackReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>,
    { data: PostAssetFeedbackReport }
  > = (props) => {
    const { data } = props ?? {};

    return putApiSelflearnPostAssetFeedBackReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiSelflearnPostAssetFeedBackReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>
>;
export type PutApiSelflearnPostAssetFeedBackReportMutationBody =
  PostAssetFeedbackReport;
export type PutApiSelflearnPostAssetFeedBackReportMutationError = unknown;

/**
 * @summary Post asset feedback report
 */
export const usePutApiSelflearnPostAssetFeedBackReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>,
      TError,
      { data: PostAssetFeedbackReport },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiSelflearnPostAssetFeedBackReport>>,
  TError,
  { data: PostAssetFeedbackReport },
  TContext
> => {
  const mutationOptions =
    getPutApiSelflearnPostAssetFeedBackReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get asset types
 */
export const getApiSelflearnGetAssetTypes = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAssetTypeIds[]>(
    { url: `/api/selflearn/getAssetTypes`, method: "GET", signal },
    options,
  );
};

export const getGetApiSelflearnGetAssetTypesQueryKey = () => {
  return [`/api/selflearn/getAssetTypes`] as const;
};

export const getGetApiSelflearnGetAssetTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSelflearnGetAssetTypesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>
  > = ({ signal }) => getApiSelflearnGetAssetTypes(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnGetAssetTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>
>;
export type GetApiSelflearnGetAssetTypesQueryError = unknown;

export function useGetApiSelflearnGetAssetTypes<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAssetTypes<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnGetAssetTypes<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset types
 */

export function useGetApiSelflearnGetAssetTypes<
  TData = Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnGetAssetTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnGetAssetTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get personalized topics
 */
export const getApiSelflearnV2GetPersonalizedTopics = (
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GuidedLearningTopicsResponse>(
    {
      url: `/api/selflearn/v2/getPersonalizedTopics`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetApiSelflearnV2GetPersonalizedTopicsQueryKey = (
  params?: GetApiSelflearnV2GetPersonalizedTopicsParams,
) => {
  return [
    `/api/selflearn/v2/getPersonalizedTopics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiSelflearnV2GetPersonalizedTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiSelflearnV2GetPersonalizedTopicsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>
  > = ({ signal }) =>
    getApiSelflearnV2GetPersonalizedTopics(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiSelflearnV2GetPersonalizedTopicsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>
>;
export type GetApiSelflearnV2GetPersonalizedTopicsQueryError = unknown;

export function useGetApiSelflearnV2GetPersonalizedTopics<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetPersonalizedTopics<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
          TError,
          Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiSelflearnV2GetPersonalizedTopics<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get personalized topics
 */

export function useGetApiSelflearnV2GetPersonalizedTopics<
  TData = Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
  TError = unknown,
>(
  params: GetApiSelflearnV2GetPersonalizedTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiSelflearnV2GetPersonalizedTopics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiSelflearnV2GetPersonalizedTopicsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
